module.exports = __webpack_public_path__ + "img/my_qrcode_lingying.9ac30e2.png";